import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { articleListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function ArticleList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [articleData, setArticleData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getArticle = async (params) => {
    const path = "admin/articles";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setArticleData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getArticle({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getArticle(allFilter);
  };

  const data = articleData?.map((item) => {
    return {
      ...item,
      faStatus: utils?.ARTICLE_STATUS[item?.status]?.name,
      key: item._id,
      id: item._id,
    };
  });

  console.log(data);

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-article", { state: singleUser });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست مقالات"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={articleListColumns} rows={data} onEdit={editUser} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
